<template>
    <div>
        <div class="space-y-4">
            <div class="space-y-2">
                <label class="block text-sm">Embed code</label>
                <textarea
                    v-model="data.embed_code"
                    class="w-full border border-gray-300 rounded p-3 text-sm font-mono focus:ring-0 focus:border-gray-400"
                    rows="8"
                    placeholder="Paste your HTML or JavaScript embed code here..."
                ></textarea>
                <p class="text-xs text-gray-400">Only HTML and JavaScript code is accepted. The code will be rendered as-is on the public page.</p>
            </div>

            <toggle
                v-if="showSectionToggle"
                v-model="data.include_section"
                size="medium"
                title="Include code into section"
            >
                <template #description>Wrap the embed code inside a styled content section.</template>
            </toggle>
        </div>
    </div>
</template>

<script setup>
const props = defineProps({
    data: Object,
    showSectionToggle: {
        type: Boolean,
        default: false,
    },
});

if (props.showSectionToggle && props.data.include_section === undefined) {
    props.data.include_section = false;
}
</script>
